import { ComponentChild } from 'preact'

import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface MaskProps extends SharedProps {
  image: ComponentChild
  variant: 'quiz-mask' // Add more variants as needed
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/mask](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/mask)
 * - Storybook: [Mask](https://designsystem.dn.se/?path=/docs/section-subcomponents-mask--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/mask/mask.scss'`
 */
export const Mask = ({ image, variant, classNames, attributes }: MaskProps) => {
  const componentClassName = 'ds-mask'

  const classes = formatClassString([
    componentClassName,
    variant ? `${componentClassName}--${variant}` : '',
    classNames,
  ])

  const maskStyle = {
    clipPath: `url(#${variant})`,
  }

  return (
    <div className={classes} {...attributes}>
      <div style={maskStyle} className={`${componentClassName}__image-wrapper`}>
        {image}
      </div>
    </div>
  )
}
